import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M200-160v-760h408l232 232v528H200Zm378-502v-198H260v640h520v-442H578ZM80-40v-679h60v619h498v60H80Zm180-820v198-198 640-640Z"
  })
}), "FileCopy");